import queryString from 'query-string';

export const isAuthRequired = () =>
  process.env.REACT_APP_AUTH_REQUIRED === "yes" ? true : false;

export const isLoggedin = () =>
  localStorage.getItem("loggedIn") === "1" || !isAuthRequired();

export const isInternalURL = (to) => {
  try {
    const url = new URL(to, window.location.origin);
    return url.hostname === window.location.hostname;
  } catch {
    return false;
  }
};

export const isIFRAMEUrl = () => {
  const values = queryString.parse(location.search);
  if(values.iframe==1) {
    return true;
  }
  return false;
}

export const isCostco = () => {
  const values = queryString.parse(location.search);
  if(values.partner=="costco") {
    return true;
  }
  return false;
}

export const isPartnerURL = () => {
  const values = queryString.parse(location.search);
  if(values.partner) {
    return true;
  }
  return false;
}

export const definePartner = () => {
  const values = queryString.parse(location.search);
  switch(values.partner)  {
    case 'costco':
      return 'costco';
    default:
      return false;
  }
}

export const defineFilter = () => {
  const values = queryString.parse(location.search);
  switch(values.filter) {
    case '1':
      return 'filter1';
    case '2':
      return 'filter2';
    default:
      return false;
  }
}

export const isONLYPC = () => {
  const values = queryString.parse(location.search);
  if(isIFRAMEUrl() && (values.onlyPC==1) || values.type==1) {
    return true;
  }
  return false;
}

export const defineTypeCase = () => {
  const values = queryString.parse(location.search);
  if(isIFRAMEUrl()) {
    switch(values.type)  {
      case '1':
        return 'one';
      case '2':
        return 'two';
      case '3':
        return 'three';
      case '4':
        return 'four';
      case '5':
        return 'five';
      case '6':
        return 'six';
      case '7':
        return 'seven';
      default:
        return false;
    }
  }
  return false;
}

/*
 * argument sourceUrl = @string
 * argument compareUrl = @string
 * argument postion = @any
 * argument derivative = @string
 * return @boolean
 */
export const comparePath = (sourceUrl = '', compareUrl = '', postion = 0, derivative = '') => {
  let bool = false;
  if(sourceUrl && compareUrl && postion) {
    let srcArray = sourceUrl.split(derivative);
    let cmpArray = compareUrl.split(derivative);

    bool = srcArray[postion] === cmpArray[postion];
  }
  return bool;
};
